import { UserHistoryDTO } from "@shaarp/common";
import { DataTable } from "../data-table/data-table";
import { dataTableUsersHistoryColumns } from "./data-table-users-history-columns";

export default function DataTableUsersHistory({
  usersHistory,
}: {
  usersHistory: UserHistoryDTO[];
}) {
  return (
    <DataTable data={usersHistory} columns={dataTableUsersHistoryColumns()} />
  );
}
